<template>
  <DialogTemplate
    class="cancelation-dialog"
    :class="{ 'cancelation-dialog_large': activeStep === 1 }"
    :contentStyle="'min-height:30rem'"
  >
    <!-- {{ activeStep }} -->
    <div
      v-if="activeStep === 0"
      class="cancelation-step"
    >
      <div class="cancelation-step_step mb-4">
        <div class="cancelation-step_step_title">
          {{ $t('sub_cancelation.which_plan_cancel') }}
        </div>
      </div>

      <TierTag
        v-for="item in purchasedSubsNoCancel"
        :key="item.public_id"
        class="tier-tag_btn mb-2"
        :paymentInterval="item.plan.interval"
        :customGame="item.plan.type"
        :customTier="item.plan.tier"
        :hasIcon="true"
        :hasInterval="false"
        :hasTier="false"
        :isSimple="false"
        @click="selectPlanType(item)"
      />
    </div>

    <div
      v-if="activeStep === 1"
      class="cancelation-step"
    >
      <div class="cancelation-step_step">
        <div class="cancelation-step_step_title">
          {{ $t('sub_cancelation.before_you_go') }}
        </div>
        <div class="cancelation-step_step_sub">
          {{ $t('sub_cancelation.by_downgrading') }}
        </div>
      </div>
      <TimerSlideshow
        class="mt-4"
        :features="features"
      />
    </div>

    <div
      v-if="activeStep === 2"
      class="cancelation-step"
    >
      <div class="cancelation-step_step">
        <div class="cancelation-step_step_title">
          {{ $t('sub_cancelation.tell_us_why') }}
        </div>

        <TierTag
          class="mt-4"
          :paymentInterval="l_selectedSub.plan.interval"
          :customGame="l_selectedSub.plan.type"
          :customTier="l_selectedSub.plan.tier"
          :hasInterval="false"
          :hasTier="false"
          :hasIcon="true"
          :isSimple="false"
        />
        <v-radio-group
          :model-value="selectedRadio"
          class="mt-4"
          hide-details
          @update:model-value="handleRadioInput"
        >
          <div
            v-for="option in radioOptions"
            :key="option.id"
            class="my-2 f-column"
            :data-tst="`reason_${option.id.toLowerCase().split(' ').join('_')}`"
          >
            <v-radio
              class="label-white"
              :value="option.id"
              :label="option.label"
            >
            </v-radio>

            <GwInput
              v-if="selectedRadio === option.id && selectedRadio === 'Other'"
              class="mt-4 anim-fade-in ml-2"
              :placeholder="$t('sub_cancelation.other_placeholder')"
              type="text"
              autofocus
              :isTextArea="true"
              :getErrors="() => []"
              :value="userFeedback"
              @input="(_e, value) => (userFeedback = value)"
            />
            <div
              v-if="selectedRadio === option.id && selectedRadio !== 'Other'"
              class="px-4 py-2 radio-subtitle-box"
            >
              <div v-if="selectedOption">
                {{ selectedOption.subtitle }}
                <div
                  class="cursor-pointer"
                  :class="selectedOption.chat ? '' : 'radio-subtitle-box_link'"
                  @click="selectedOption.fn()"
                >
                  {{ selectedOption.link }}
                  <OpenChatLink
                    v-if="selectedOption.chat"
                    :text="$t('common.here')"
                  />
                  .
                </div>
              </div>
            </div>
          </div>
        </v-radio-group>
      </div>
    </div>

    <div
      v-if="activeStep === 3"
      class="cancelation-step"
      data-tst="cancel_success"
    >
      <div class="cancelation-step_step">
        <v-icon
          size="x-large"
          color="primary"
          >mdi-checkbox-marked-circle-outline</v-icon
        >
        <div
          class="cancelation-step_step_title mt-2"
          v-html="
            $t('sub_cancelation.canceled_subscription', {
              subscription_tier: tierFullName,
            })
          "
        ></div>
        <div
          class="cancelation-step_step_sub mt-4"
          v-html="
            $t('sub_cancelation.tier_subscription_canceled', {
              subscription_tier: tierFullName,
              subscription_expiration,
            })
          "
        ></div>
      </div>
    </div>

    <div
      v-if="activeStep === 4"
      class="cancelation-step"
    >
      <div class="cancelation-step_step">
        <v-icon
          size="x-large"
          color="var(--clr-error)"
          >mdi-alert-circle-outline</v-icon
        >
        <div class="cancelation-step_step_title mt-2">
          {{ $t('sub_cancelation.cancelation_failed') }}
        </div>
        <div class="cancelation-step_step_sub mt-4">
          {{ $t('sub_cancelation.try_contacting') }}
          <OpenChatLink />
          {{ $t('sub_cancelation.sorry_for_tech_difficulties') }}
        </div>
      </div>
    </div>

    <template #dialog_actions>
      <v-btn
        v-if="activeStep < 3"
        class="mr-auto"
        data-tst="btn_cancel_dont"
        color="transparent"
        @click.stop="close({ segAction: `Don't Cancel click` })"
      >
        {{ $t('btn.cancel_dont') }}
      </v-btn>

      <div
        v-if="activeStep < 3 && !smallScreen"
        class="cancelation-steps ma-auto"
      >
        {{ $t('btn.step') }}
        {{ activeStep }} / 2
      </div>

      <v-btn
        v-if="activeStep === 2"
        class="ml-auto"
        color="primary"
        data-tst="btn_cancel_subscription"
        :loading="loading"
        :disabled="selectedRadio === 'unset' || (selectedRadio === 'Other' && !userFeedback)"
        @click="cancelSubsription"
      >
        {{ $t('btn.cancel_subscription') }}
      </v-btn>
      <v-btn
        v-else-if="activeStep === 3 || activeStep === 4"
        class="ml-auto"
        color="primary"
        data-tst="btn_close"
        @click="close({ segAction: `Close` })"
        >{{ $t('btn.close') }}</v-btn
      >
      <v-btn
        v-else
        color="primary"
        class="ml-auto"
        data-tst="btn_continue"
        :disabled="activeStep === 0"
        @click="handleContinue()"
        >{{ $t('btn.continue') }}</v-btn
      >
    </template>
  </DialogTemplate>
</template>

<script>
import DialogTemplate from '@/components/Dialogs/DialogTemplate'
import TierTag from '@/components/Sub/TierTag'
import { gtm_sub_cancel } from '@/helpers/gtm'
import format_mix from '@/mixins/format_mix'
import tier_mix from '@/mixins/tier_mix'
import links_mix from '@/mixins/links_mix'
import GwInput from '@/components/lib/GwInput'
import OpenChatLink from '@/components/Payments/OpenChatLink.vue'
import TimerSlideshow from './TimerSlideshow'

export default {
  name: 'CancelPaymentPlanDialog',
  components: {
    OpenChatLink,
    DialogTemplate,
    TierTag,
    TimerSlideshow,
    GwInput,
  },
  mixins: [format_mix, tier_mix, links_mix],
  data() {
    return {
      activeStep: 0,
      // activeStep: 2,
      // activeStep: 3,
      // activeStep: 4,
      steps: [0, 1, 2, 3],

      selectedRadio: 'unset',
      userFeedback: '',
      loading: false,
      l_selectedSub: null,
    }
  },
  mounted() {
    if (this.purchasedSubsNoCancel.length === 1) {
      this.selectPlanType(this.purchasedSubsNoCancel[0])
    } else {
      // seg_track('cancel_subscription_plans_viewed', {
      //   products: this.purchasedSubs.map(i => ({
      //     ...seg_getProduct(i),
      //     quantity: 1,
      //   })),
      // })
    }
  },
  methods: {
    selectPlanType(item) {
      const sub = this.subs.find(i => i.plan.type === item.plan.type)

      this.l_selectedSub = JSON.parse(JSON.stringify(sub))
      // seg_track('cancel_subscription_step_viewed', {
      //   step: 1,
      //   products: [
      //     {
      //       ...seg_getProduct(this.l_selectedSub),
      //       quantity: 1,
      //     },
      //   ],
      // })

      this.activeStep = 1
      // console.log(this.l_selectedSub)
      // this.activeStep = 2
      // this.activeStep = 3
      // this.activeStep = 4
    },
    handleContinue() {
      this.activeStep += 1
      if (this.activeStep === 2) {
        // seg_track('cancel_subscription_step_viewed', {
        //   step: 2,
        //   products: [
        //     {
        //       ...seg_getProduct(this.l_selectedSub),
        //       quantity: 1,
        //     },
        //   ],
        // })
      }
    },
    handleRadioInput(value) {
      this.selectedRadio = value
    },
    close({ segAction = `Don't Cancel click` }) {
      // seg_track('cancel_subscription_step_completed', {
      //   step: this.step,
      //   action: segAction,
      //   products: [
      //     {
      //       ...seg_getProduct(this.l_selectedSub),
      //       quantity: 1,
      //     },
      //   ],
      // })
      this.$store.dispatch('router_reset_dialogs')
    },
    async cancelSubsription() {
      if (this.l_selectedSub.plan.provider === 'Gtowizard') {
        this.activeStep += 1
      } else {
        // seg_track('cancel_subscription_step_completed', {
        //   step: 2,
        //   action: 'Cancel Subscription Click',
        //   cancel_reason: this.selectedRadio,
        //   products: [
        //     {
        //       ...seg_getProduct(this.l_selectedSub),
        //       quantity: 1,
        //     },
        //   ],
        // })

        this.loading = true
        const data = {
          public_id: this.l_selectedSub.public_id,
          reason_id: this.selectedRadio,
          ...(this.selectedRadio === 'Other' ? { reason: this.userFeedback } : {}),
        }
        const res = await this.$store.dispatch('api_call', {
          method: 'DELETE',
          endpoint: 'payments/subscription/',
          hasCancel: false,
          data,
        })
        if (res?.response?.status === 200 || res?.response?.status === 204) {
          gtm_sub_cancel({
            currencyCode: 'USD',
            game: this.l_selectedSub.plan.type,
            type: this.l_selectedSub.plan.tier.toLowerCase(),
          })

          await this.$store.dispatch('api_call', {
            method: 'get',
            endpoint: 'account/settings/',
            hasCancel: false,
            mutation: 'api_account_settings',
            action: 'updateUserInfo',
          })
          this.$store.dispatch('gameformats_reinitialize_after_tier_update')

          this.activeStep += 1
        } else {
          this.activeStep += 2
        }
        this.loading = false
      }
    },
  },
  computed: {
    subscription_expiration() {
      // console.log(this.l_selectedSub)
      if (this.l_selectedSub.expiration_date) {
        return this.formatISODate(this.l_selectedSub.expiration_date)
      }
      return null
    },
    tierFullName() {
      // console.log(this.l_selectedSub)
      return `${this.$t(`gametypes.groups.${this.l_selectedSub.plan.type.toLowerCase()}_long`)} /
              ${this.$t(`tier.options.${this.l_selectedSub.plan.tier}`)} / ${this.$t(
                `tier.options.${this.l_selectedSub.plan.interval}`,
              )}`
    },
    radioOptions() {
      return [
        // keep ids readable for segment/analytics
        {
          id: 'Have no need for it',
          label: this.$t('sub_cancelation.reason.no_need'),
          subtitle: this.$t('sub_cancelation.reason.no_need_sub'),
          link: this.$t('sub_cancelation.reason.no_need_link'),
          fn: () => {
            this.$router.replace({
              name: 'Subscription',
            })
          },
        },
        {
          id: 'Price to high',
          label: this.$t('sub_cancelation.reason.price'),
          subtitle: this.$t('sub_cancelation.reason.price_sub'),
          link: this.$t('sub_cancelation.reason.price_link'),
          fn: () => {
            this.$router.replace({
              name: 'UserSubscription',
              query: { dialogs: 'update-payment-plan-dialog' },
            })
          },
        },
        {
          id: 'Free version is good enough',
          label: this.$t('sub_cancelation.reason.free'),
          subtitle: this.$t('sub_cancelation.reason.free_sub'),
          link: this.$t('sub_cancelation.reason.free_link'),
          fn: () => {
            this.$router.replace({
              name: 'Subscription',
            })
          },
        },
        {
          id: 'Technical difficulties',
          label: this.$t('sub_cancelation.reason.technical'),
          subtitle: this.$t('sub_cancelation.reason.technical_sub'),
          link: this.$t('sub_cancelation.reason.technical_link'),
          fn: () => {
            this.$router.replace({ query: {} })
          },
          chat: true,
        },
        {
          id: 'Other',
          label: this.$t('sub_cancelation.reason.other'),
        },
      ]
    },
    features() {
      const path = !this.smallScreen ? 'features/bigger/' : 'features/'
      if (this.l_selectedSub.plan.tier === 'STARTER') {
        return [
          {
            id: 0,
            title: this.$t('sub_cancelation.features.unlimited_solutions'),
            subtitle: this.$t('sub_cancelation.features.unlimited_solutions_sub'),
            img: `${path}2.webp`,
          },
          {
            id: 1,
            title: this.$t('sub_cancelation.features.unlimited_spots'),
            subtitle: this.$t('sub_cancelation.features.unlimited_spots_sub'),
            img: `${path}3.webp`,
          },
          {
            id: 2,
            title: this.$t('sub_cancelation.features.hands_month', { starter_hands_mo: 50 }),
            subtitle: this.$t('sub_cancelation.features.hands_month_sub', { starter_hands_mo: 50 }),
            img: `${path}4.webp`,
          },
        ]
      }
      return [
        {
          id: 0,
          title: this.$t('sub_cancelation.features.unlimited_solutions'),
          subtitle: this.$t('sub_cancelation.features.unlimited_solutions_sub'),
          img: `${path}2.webp`,
        },
        {
          id: 1,
          title: this.$t('sub_cancelation.features.unlimited_spots'),
          subtitle: this.$t('sub_cancelation.features.unlimited_spots_sub'),
          img: `${path}3.webp`,
        },
        {
          id: 2,
          title: this.$t('sub_cancelation.features.thousand_hands', {
            premium_hands_mo: (100000).toLocaleString(this.$i18n.locale),
          }),
          subtitle: this.$t('sub_cancelation.features.thousand_hands_sub', {
            premium_hands_mo: (100000).toLocaleString(this.$i18n.locale),
          }),
          img: `${path}4.webp`,
        },
        {
          id: 3,
          title: this.$t('sub_cancelation.features.weekly_coaching'),
          subtitle: this.$t('sub_cancelation.features.weekly_coaching_sub'),
          img: `${path}10.webp`,
        },
      ]
    },
    selectedOption() {
      return this.radioOptions.find(i => i.id === this.selectedRadio)
    },
    smallScreen() {
      const { globals_window_size } = this.$store.getters
      return globals_window_size.width < 768
    },
  },
}
</script>

<style lang="scss" scoped>
.cancelation-dialog {
  &_large {
    width: 63rem !important;
  }
  width: 37rem;
  transition: 0.4s ease;
}
.cancelation-steps {
  font-size: 0.8rem;
  color: var(--clr-grey-2);
  padding: 0 1rem;
}
.cancelation-step {
  padding: 1rem;
  width: 100%;
  &_step {
    &_title {
      font-size: 1.5rem;
      font-weight: 700;
    }
    &_sub {
      // display: flex;
      font-size: 1rem;
      font-weight: 500;
    }
  }
}
.radio-subtitle-box {
  background: var(--clr-black-3);
  border-radius: 4px;
  font-weight: 500;
  &_link {
    font-weight: 700;
    color: var(--clr-blue);
  }
}
</style>
